module.exports = __webpack_public_path__ + "img/restart.61f08503.png";